module.exports = __webpack_public_path__ + "media/newstyle/images/user-book-f8e7dac089040ff586b8d20927fe9334.png";